import { render, staticRenderFns } from "./FaceTake.vue?vue&type=template&id=3bb46dca&scoped=true&"
import script from "./FaceTake.vue?vue&type=script&lang=js&"
export * from "./FaceTake.vue?vue&type=script&lang=js&"
import style0 from "./FaceTake.vue?vue&type=style&index=0&id=3bb46dca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb46dca",
  null
  
)

export default component.exports